import React from 'react';
import Search from './Search';
import NAICSCodeInfoTab from './naicsCodeInfo/NaicsCodeInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as App from 'modules/app/App'
import * as API from 'modules/app/API'

class NaicsCodeSetup extends React.Component {
    render() {
        let opts = {
			setupKey: "NAICSCode",
            title: "NAICS Codes",
            description: "Create, modify, and remove NAICS Codes and Descriptions",
            addNewTitle: "Add new NAICS Code",
			addPrivilege: App.hasPrivilege("AdminNAICSCodeSetupAdd"),
            enableColumnSettings: true,
            showTitle: false,
            recentType: "NAICSCode",
            list: {
                url: API.App.url('/NAICSCodeSetup/search'),
                rowKey: "code",
                columns: [
                    { key: 'code', name: 'Code', width:100, sortable: true },
                    { key: 'categoryDescription', name: 'Title', width:400 },
                    { key: 'description', name: 'Description' }
                ]
            },
            tabs: [
                { key: "NAICSCode", title: "NAICS Code", comp: NAICSCodeInfoTab },
            ]
        };

        return (
            <SetupPage {...opts}
                Search={Search} />
        );
    }
}
export default NaicsCodeSetup;



// WEBPACK FOOTER //
// ./src/areas/admin/naicsCodeSetup/NaicsCodeSetup.js